import React from 'react';
import InfoText from '../atoms/InfoText';
import { Avatar } from 'antd';
import CardWrapper from './CardWrapper';
import { useTranslation } from 'react-i18next';

export interface LogUserCardProps {
  name?: string;
  email?: string;
  avatarUrl?: string;
  role?: string;
}

export const LogUserCard: React.FC<LogUserCardProps> = ({
  name,
  email,
  avatarUrl,
  role,
}) => {
  const { t } = useTranslation();

  return (
    <CardWrapper title={t('configLogs.createdBy')}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {avatarUrl ? (
            <Avatar src={avatarUrl} alt={name} size={48} />
          ) : (
            <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 font-bold text-lg border border-gray-200">
              {name ? name.charAt(0).toUpperCase() : 'U'}
            </div>
          )}
          <div className="flex flex-col">
            <InfoText
              text={name || '-'}
              className="text-base font-bold text-light-text-primary"
            />
            {email && (
              <InfoText
                text={email}
                className="text-sm font-normal text-light-text-primary"
              />
            )}
          </div>
        </div>

        {role && (
          <InfoText
            text={role}
            className="text-sm font-medium text-light-text-primary"
          />
        )}
      </div>
    </CardWrapper>
  );
};

export default LogUserCard;
